import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { Response } from "~types/response.ts";

type PersonInRosterType = {
  seasonId?: string;
  personId?: string;
  fixtureId?: string;
};

export const useIsPersonInRoster = () => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  return useMutation<boolean, unknown, PersonInRosterType>({
    mutationFn: ({ seasonId, personId, fixtureId }: PersonInRosterType) => {
      let url = `${sport}/o/${organizationId}/seasons/${seasonId}/persons/${personId}/roster`;
      if (fixtureId) {
        url = `${sport}/o/${organizationId}/fixtures/${fixtureId}/persons/${personId}/roster`;
      }

      return request<Response<unknown>>(url, {
        method: "GET",
        onError: { 404: () => {} },
      })
        .then((response) => response?.data?.length > 0)
        .catch(() => false);
    },
  });
};
